import { useState, ChangeEvent, FormEvent } from "react";
import axiosCAF from "../../components/Config/AxiosIni";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { SelectChangeEvent } from "@mui/material/Select";

interface FormData {
    nombre: string;
    apellido: string;
    tipoDocumento: string;
    nroDocumento: string;
    email: string;
    fechaNacimiento: string;
    password: string;
    confirmPassword: string;
    estado:string;
    perfil:string;
    avatar:string;
}

type FormErrors = Partial<Record<keyof FormData, string>>;

const initialFormData: FormData = {
    nombre: "",
    apellido: "",
    tipoDocumento: "",
    nroDocumento: "",
    email: "",
    fechaNacimiento: "",
    password: "",
    confirmPassword: "",
    estado: "Inactivo",
    perfil: "Socio",
    avatar: "avatar.png",
  };

export const useUserRegister = () => {

    const [formData, setFormData] = useState<FormData>(initialFormData);
    const [errors, setErrors] = useState<FormErrors>({});
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    //* Funcion para Resetear el Form Registro
    const resetForm = () => {
        setFormData(initialFormData);
        setErrors({});
    };
    //* 
    const handleChangeSelect = (event: SelectChangeEvent<string>) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleChange = (
        e: ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>
    ) => {
        const { name, value } = e.target;
        if (name) {
        setFormData({ ...formData, [name]: value });
        }
    };
    //* Funcion para validar que se ingresen los datos en box
    const validate = (): boolean => {
        const tempErrors: FormErrors = {};

        if (!formData.nombre) tempErrors.nombre = "El nombre es obligatorio";
        if (!formData.apellido) tempErrors.apellido = "El apellido es obligatorio";
        if (!formData.email) tempErrors.email = "El correo es obligatorio";
        if (!formData.tipoDocumento)
        tempErrors.tipoDocumento = "El tipo de documento es obligatorio";
        if (!formData.nroDocumento)
        tempErrors.nroDocumento = "El número de documento es obligatorio";
        if (!formData.fechaNacimiento)
        tempErrors.fechaNacimiento = "La fecha de nacimiento es obligatoria";
        if (!formData.password)
        tempErrors.password = "La contraseña es obligatoria";
        else if (formData.password.length < 6)
        tempErrors.password = "Debe tener al menos 6 caracteres";

        if (!formData.confirmPassword)
        tempErrors.confirmPassword = "Debe confirmar la contraseña";
        else if (formData.password !== formData.confirmPassword)
        tempErrors.confirmPassword = "Las contraseñas no coinciden";

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };
    //* Funcio pora grabar los datos en la DB
    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        console.log('ariel-DatosUser',formData);
        e.preventDefault();
        if (!validate()) return;

        try {
        setLoading(true);
        const { data } = await axiosCAF.post("/auth/register", formData);
        Swal.fire({
            title: "Registro de Usuario",
            text: data?.message,
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
        }).then((result) => {
            if (result.isConfirmed) {
                resetForm();
            }
        });
        } catch (error: any) {
        Swal.fire(
            "Error",
                error?.response?.data?.message || "Ocurrió un error inesperado",
            "error"
        );
        } finally {
        setLoading(false);
        }
    };

    return {
        formData,
        errors,
        loading,
        handleChange,
        handleSubmit,
        handleChangeSelect,
    };
};
